import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Docs from './Docs';
import { Router, Route, hashHistory } from 'react-router';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import './index.css';
import reducer from './reducers';
import 'react-fastclick';

const store = createStore(reducer);

ReactDOM.render(
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path={`${process.env.PUBLIC_URL}/`} component={App}></Route>
      <Route path={`${process.env.PUBLIC_URL}/docs`} component={Docs}></Route>
    </Router>
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/